/* ==========================================================================
   MONA CART — AJAX quantity updates + remove on the cart page.

   Rewritten to fix "cart changes items by itself":
   1. Lines are addressed by item KEY, not line number. Line numbers shift
      whenever an item is removed, so the old code could increment or delete
      a different product than the one clicked.
   2. All mutations run through one promise queue — rapid +/‑ clicks or a
      typed quantity followed by a click can no longer race each other.
   3. After every response the whole list is reconciled against the returned
      cart by key, so the DOM always matches Shopify's state.
   ========================================================================== */
(function () {
  'use strict';
  var page = document.querySelector('[data-mona-cart-page]');
  if (!page) return;

  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var queue = Promise.resolve();          // serialises every cart mutation

  function money(cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'CAD' }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function changeByKey(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) { throw new Error('cart/change ' + r.status); }
      return r.json();
    });
  }

  function reconcile(cart) {
    var byKey = {};
    (cart.items || []).forEach(function (it) { byKey[it.key] = it; });

    page.querySelectorAll('[data-mona-cart-item]').forEach(function (el) {
      var it = byKey[el.getAttribute('data-key')];
      if (!it) { el.remove(); return; }
      var input = el.querySelector('[data-mona-qty-input]');
      if (input && document.activeElement !== input) input.value = it.quantity;
      var lp = el.querySelector('[data-mona-line-price]');
      if (lp) lp.textContent = money(it.final_line_price);
    });

    var sub = page.querySelector('[data-mona-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    var count = document.querySelector('[data-mona-cart-count]');
    if (count) { count.textContent = cart.item_count; count.classList.toggle('is-empty', cart.item_count === 0); }
    if (cart.item_count === 0) window.location.reload();
  }

  function enqueue(key, qty) {
    queue = queue
      .then(function () { return changeByKey(key, qty); })
      .then(reconcile)
      .catch(function () { window.location.reload(); });  // never leave DOM and cart out of sync
    return queue;
  }

  function keyFor(el) {
    var item = el.closest('[data-mona-cart-item]');
    return item ? item.getAttribute('data-key') : null;
  }

  page.addEventListener('click', function (e) {
    var up = e.target.closest('[data-mona-qty-up]');
    var down = e.target.closest('[data-mona-qty-down]');
    var remove = e.target.closest('[data-mona-cart-remove]');
    if (!up && !down && !remove) return;

    var key = keyFor(e.target);
    if (!key) return;

    if (remove) { enqueue(key, 0); return; }

    var input = e.target.closest('[data-mona-qty]').querySelector('[data-mona-qty-input]');
    var qty = parseInt(input.value, 10);
    if (isNaN(qty)) qty = 1;
    qty += (up ? 1 : -1);
    if (qty < 0) qty = 0;
    input.value = qty;                    // synchronous, so rapid clicks stack correctly
    enqueue(key, qty);
  });

  page.addEventListener('change', function (e) {
    var input = e.target.closest('[data-mona-qty-input]');
    if (!input) return;
    var key = keyFor(input);
    if (!key) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    input.value = qty;
    enqueue(key, qty);
  });
})();
